import React from 'react'

const Subtraction = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<rect fill="currentColor" height="20" rx="1" transform="rotate(-90 3 14)" width="2" x="3" y="14"></rect>
</svg>
    )
}

export default Subtraction
